export default "__VITE_ASSET__DQ2IXHl1__"